import React from 'react';
import GeneratorBase from './GeneratorBase';
import { usePostingTime } from '../hooks/usePostingTime';

const BusinessPostGenerator = () => {
  const postingTimeSummary = usePostingTime();

  const fields = [
    {
      name: 'topic',
      label: 'Topic',
      type: 'text',
      placeholder: 'e.g., Digital Marketing Trends 2024',
      required: true
    },
    {
      name: 'keywords',
      label: 'Keywords',
      type: 'text',
      placeholder: 'e.g., digital marketing, branding, strategy',
      required: true
    },
    {
      name: 'tone',
      label: 'Tone',
      type: 'select',
      options: [
        { value: 'professional', label: 'Professional' },
        { value: 'friendly', label: 'Friendly' },
        { value: 'formal', label: 'Formal' }
      ],
      required: true
    },
    {
      name: 'targetAudience',
      label: 'Target Audience',
      type: 'text',
      placeholder: 'e.g., Marketing professionals, Small business owners',
      required: true
    }
  ];

  return (
    <GeneratorBase
      title="Business Post Generator"
      description="Create engaging LinkedIn business posts with strong hooks, valuable content, and clear CTAs. Perfect for B2World Branding marketing campaigns."
      fields={fields}
      apiEndpoint="business-post"
      saveDraftEndpoint="business-post"
      enableLinkedIn={true}
      postingTimeSummary={postingTimeSummary}
      buttonIcon="/logo.png"
    />
  );
};

export default BusinessPostGenerator;
